import { Lock } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-8 bg-dark border-t border-[#e5b54b]/25" data-testid="site-footer">
      <div className="px-6 py-10 text-center">
        <h3 className="font-bold text-3xl sm:text-4xl leading-tight text-[#ffd700]">
          Royal Market
        </h3>
        <p className="text-[#d8cfa3] text-sm mt-3">
          Powered By <span className="text-[#ffd700] font-semibold">ROYAL MARKET</span>
        </p>
        <div className="flex items-center justify-center gap-4 pt-5 text-xs text-[#8a8266]">
          <span>© {new Date().getFullYear()} Royal Market</span>
          <span>•</span>
          <Link to="/admin/login" className="hover:text-[#ffd700] transition-colors inline-flex items-center gap-1" data-testid="admin-link">
            <Lock className="w-3 h-3" /> Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
